import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Button, Row } from "react-bootstrap";
import Image from "../../assets/nike.png";
import Image2 from "../../assets/deny.png";
import "../../components/button/button.css";
import "./emailRes.css";
import "../../components/button/button.css";

const EmailRes = (props) => {
  return (
    <>
      {props.result === "1" && (
        <Container className="vh-100 d-flex flex-column  align-items-center">
          <div className="text-center mx-auto emailres-img-container">
            <img src={Image} alt="Time" className="emailres-img" />
          </div>
          <div className="text-center emailres-ver">
            <p>
              <b>Email 驗證完成</b>
            </p>
          </div>
          <div className="text-center mt-5">
            <p>
              <b style={{ color: "gray" }}>點擊下方「登入」按鈕</b>
            </p>
            <Button
              className="btn-custom-green w-100 mt-1 d-flex align-items-center justify-content-center"
              style={{ height: "40%" }}
              onClick={() => {
                window.location.href =
                  `https://line.me/R/app/${process.env.REACT_APP_LIFF_ID}/register`;
              }}
            >
              登入
            </Button>
          </div>
          <div className="emailres-company text-center mx-auto w-100">
            <p>
              <b>元大牙科儀器股份有限公司</b>
            </p>
          </div>
        </Container>
      )}
      {(!props.result || props.result === "0") && (
        <Container className="vh-100 d-flex flex-column  align-items-center">
          <div className="text-center mx-auto emailres-img-container">
            <img src={Image2} alt="Time" className="emailres-img" />
          </div>
          <div className="text-center emailres-ver">
            <p>
              <b>Email 驗證失敗</b>
            </p>
          </div>
          <div className="text-center mt-5" style={{ color: "gray" }}>
            <p>
              <b>請聯絡客服或重新驗證</b>
            </p>
          </div>
          <div className="emailres-company text-center mx-auto w-100">
            <p>
              <b>元大牙科儀器股份有限公司</b>
            </p>
          </div>
        </Container>
      )}
    </>
  );
};

export default EmailRes;
